import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Circle, Table, Title } from 'utils/skeletons';
import { Skeleton } from '@material-ui/lab';
import { randomString } from 'utils/functions';
import { makeStyles } from '@material-ui/styles';
import styles from './styles';

const useStyles = makeStyles(styles);
const VehicleSkeleton = () => {
  const Filter = () => (
    Array.from(new Array(4)).map(() => (
      <Grid key={randomString()} item xs={3}>
        <Skeleton variant="rect" width="100%" height={50} />
      </Grid>
    ))
  );

  const Rect = () => <Skeleton variant="rect" width="80%" height={120} />;
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={1}
    >
      <Grid item xs={12}>
        <Title width={100} />
      </Grid>
      <Filter />
      <Grid item xs={6} md={3} align="center" className={classes.grid}>
        <Circle width={140} height={140} />
      </Grid>
      <Grid item xs={6} md={3} align="center" className={classes.grid}>
        <Circle width={140} height={140} />
      </Grid>
      <Grid item xs={6} md={3} align="center" className={classes.grid}>
        <Rect />
      </Grid>
      <Grid item xs={6} md={3} align="center" className={classes.grid}>
        <Rect />
      </Grid>
      <Grid item xs={12} align="center">
        <Table cells={5} />
      </Grid>

    </Grid>
  );
};

export default VehicleSkeleton;
